import SurfaceCard from './SurfaceCard';
import Eyebrow from './Eyebrow';

export type StatTone = 'value' | 'warn' | 'error' | 'ok' | 'empty';

const TONES: Record<StatTone, string> = {
  value: 'text-white',
  warn: 'text-state-warn',
  error: 'text-state-err',
  ok: 'text-state-ok-soft',
  // an empty metric reads as absent, not as zero
  empty: 'text-navy-400',
};

/**
 * One line of fact: STATUS / CPU / RAM.
 *
 * This replaces the pair of 143px cards that used to render a ghost
 * illustration — an empty metric now costs a line of text, not half the fold.
 */
const StatCard = ({ label, value, unit, note, tone = 'value', action, className = '' }: {
  label: React.ReactNode,
  value: React.ReactNode,
  unit?: React.ReactNode,
  note?: React.ReactNode,
  tone?: StatTone,
  /** Sits on the eyebrow's line, right-aligned — for the one fact here that
   *  can be acted on rather than only read. */
  action?: React.ReactNode,
  className?: string,
}) => (
  <SurfaceCard className={`px-4 py-4 lg:px-5 lg:py-[18px] flex flex-col gap-2 ${className}`}>
    <div className="flex items-center justify-between gap-3">
      <Eyebrow>{label}</Eyebrow>
      {action}
    </div>
    <div className="flex items-baseline gap-1.5">
      <span className={`font-sora text-ds-20 font-semibold tracking-[-0.02em] ${TONES[tone]}`}>{value}</span>
      {unit ? <span className="font-courrier text-ds-115 text-navy-300">{unit}</span> : null}
    </div>
    {note ? <span className="text-ds-115 leading-[1.5] text-navy-200">{note}</span> : null}
  </SurfaceCard>
)

export default StatCard
